<template>
  <div class="main-profile" :style="siteStyles">
    <div class="profile-header">
      <h1>MY PROFILE</h1>
    </div>
    <div class="main-box profile-border">
      <div v-if="lastReview && !reviewMode">
        <v-layout row justify-center >
          <v-dialog
            v-model="lastReview"
            persistent
            max-width="600px"
          >
            <v-card>
              <v-card-title class="justify-center">
                <h1 class="headline">Verify Your Contact Information</h1>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-container grid-list-md pt-0>
                  <p>Please help us keep your accounts secure by verifying your contact information. We use your contact information to confirm your identity and keep you informed on important account information. Simply review your information and if necessary, make any updates. Once you have confirmed your contact information, the My Alerus dashboard will appear.</p>
                </v-container>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  class="review mb-2"
                  large
                  :color="appColorHex"
                  dark
                  @click="startReview"
                >Verify Now
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </div>
      <div v-if="addTotp">
        <v-layout row justify-center>
          <v-dialog
            v-model="addTotp"
            persistent
            max-width="600px"
          >
            <v-card class="two-factor">
              <v-card-title class="justify-center">
                <div class="main-blue">Add two-factor authentication</div>
              </v-card-title>
              <v-card-text class="pa-0">
                <v-container grid-list-md pt-0 pb-0>
                  <p class="welcome-text text-xs-center">Scan the QR code below to set up two-factor authentication.</p>
                  <v-flex>
                    <qrcode-vue size="200" class="text-xs-center my-4" :value="qrVal"></qrcode-vue>
                    <!-- <h4 class="mb-1 ">Account: {{ this.user.username }}</h4>
                    <h4>Key: {{ qrCode }}</h4> -->
                    <v-text-field @keyup.enter="validateQrCode" ref="verifyCode" mask="### ###" class="mt-4" :color="appColorHex" v-model="qrValidate" label="Code"></v-text-field>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  class=""
                  depressed
                  :color="appButtonColor"
                  dark
                  @click="validateQrCode"
                  :loading="qrLoading"
                >Verify</v-btn>
                <v-btn
                  class=""
                  light
                  depressed
                  :color="appColorHex"
                  @click="cancelTotp"
                >Cancel
                </v-btn>
              </v-card-actions>
              <span class="totp-error" v-if="totpError">{{ totpError }}</span>
            </v-card>
          </v-dialog>
        </v-layout>
      </div>
      <div v-if="deviceDialog">
        <v-layout row justify-center>
          <v-dialog
            v-model="deviceDialog"
            max-width="500px"
          >
            <v-card class="py-3">
              <v-card-title class="justify-center">
                <h1 class="headline">Remove Authenticator Application?</h1>
              </v-card-title>
              <v-card-actions class="justify-center">
                <v-btn
                  class="review"
                  large
                  :color="appColorHex"
                  dark
                  @click="deviceDialog = false"
                >Cancel
                </v-btn>
                <v-btn
                  class="review"
                  large
                  :color="appColorHex"
                  dark
                  @click="deleteDevice"
                >Remove
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </div>
      <div>
        <v-form ref="form">
          <v-layout row wrap>
            <v-flex>
              <div class="main-blue">{{ userDetails.first ? `Hi, ${userDetails.first}` : 'Hello' }}</div>
              <div class="sub-text">PERSONAL INFORMATION</div>
                <!-- <v-icon :color="primaryColor">expand_more</v-icon -->
              <div class="sub-text">Name:<span> {{ userDetails.first }} {{ userDetails.last }}</span></div>
              <!-- <v-card class="profile"> -->
                <!-- <v-card-title :class="appColor" primary-title>
                  <h2>My Profile</h2>
                </v-card-title> -->
                <!-- <v-card-text class="pa-4" v-if="userDetails">
                  <v-layout row wrap px-3 py-2 mb-1 align-center justify-space-between>
                    
                    <v-btn :disabled="noDiff" :loading="saveBtn" class="hidden-xs-only save" @click="updateMultipleAtts({review: reviewMode})">{{ reviewMode ? "Save and Continue" : "Save" }}</v-btn>
                  <!-- </v-layout> -->
                  <!-- <v-layout row wrap justify-center align-center pl-2 pr-4>
                    <v-flex xs12 sm4 py-0>
                      <h3>Change Username:</h3>
                      <h3>{{ userAtts.username }}</h3>
                    </v-flex>
                    <v-flex xs11 sm7 py-0>
                      <v-text-field
                        autocomplete="new-username"
                        v-model="newUserAtts.username"
                        placeholder="New Username"
                      ></v-text-field>
                      <span :style="{color: responseStyle}">{{ usernameResponse }}</span>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn flat icon :color="color.username">
                        <v-icon @click="changeAtt('username')" medium>check_circle</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout> -->
                  <!-- <v-subheader class="pl-2 subheading">Update Contact Information</v-subheader> -->
                  <v-layout row wrap>
                    <!-- <v-flex xs12 lg5 class="input-group">
                      <div class="Input__inputLabel___3VF0S">Preferred Name:</div>
                      <input type="text" v-model="userDetails.preferredName" class="Input__input___3e_bf" />
                    </v-flex> -->
                    <v-flex xs12 lg5 class="input-group">
                      <div class="Input__inputLabel___3VF0S">Email Address:</div>
                      <input type="text" v-model="userDetails.email" class="Input__input___3e_bf" />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 lg5 class="input-group">
                      <div class="Input__inputLabel___3VF0S">Primary Phone:</div>
                      <v-select
                        :items="primaryPhone"
                        v-model="userDetails.primary"
                        item-text="title"
                        item-value="val"
                        :color="appColorHex"
                        class="default-box"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 lg5 offset-lg1 class="input-group">
                      <div class="Input__inputLabel___3VF0S">Mobile:</div>
                      <v-layout>
                        <v-flex xs4 lg5>
                          <v-select
                            class="country-select default-box"
                            v-model="currentPhones.mobile.countryCode"
                            :items="countries"
                            item-text="label"
                            item-value="value"
                            :color="appColorHex"
                            hide-details
                          ></v-select>
                        </v-flex>
                        <v-flex xs8 lg7>
                          <v-text-field
                            v-model="currentPhones.mobile.number"
                            :color="appColorHex"
                            :mask="currentPhones.mobile.countryCode === '1' ? '(###) ### - ####' : '##############'"
                            :rules="[rules.phoneRequired]"
                            class="default-box number-input"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 lg5 class="input-group">
                      <div class="Input__inputLabel___3VF0S">Home:</div>
                      <v-layout>
                        <v-flex xs4 lg5>
                          <v-select
                            hide-details
                            class="country-select default-box"
                            v-model="currentPhones.home.countryCode"
                            :items="countries"
                            item-text="label"
                            item-value="value"
                            :color="appColorHex"
                          ></v-select>
                        </v-flex>
                        <v-flex xs8 lg7>
                           <v-text-field
                              hide-details
                              class="default-box number-input"
                              v-model="currentPhones.home.number"
                              :color="appColorHex"
                              :mask="currentPhones.home.countryCode === '1' ? '(###) ### - ####' : '##############'"
                            ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 lg5 offset-lg1 class="input-group">
                      <div class="Input__inputLabel___3VF0S">Work:</div>
                      <v-layout>
                        <v-flex xs4 lg5>
                          <v-select
                            hide-details
                            class="country-select default-box"
                            v-model="currentPhones.work.countryCode"
                            :items="countries"
                            item-text="label"
                            item-value="value"
                            :color="appColorHex"
                          ></v-select>
                        </v-flex>
                        <v-flex xs8 lg7>
                          <v-text-field
                          hide-details
                          class="default-box number-input"
                          v-model="currentPhones.work.number"
                          :color="appColorHex"
                          :mask="currentPhones.work.countryCode === '1' ? '(###) ### - ####' : '##############'"
                        ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!-- <v-flex xs12 sm6>
                      <v-switch :color="appColorHex" hint="When you choose to receive text message alerts, you are agreeing to the Terms of Use. Standard text message and other rates may apply. See your carrier for details. You can cancel at any time by texting STOP to XXXXX." persistent-hint v-model="userDetails.allowText" label="Allow text messages?"></v-switch>
                    </v-flex> -->
                  </v-layout>
                  <v-btn dark depressed :color="appButtonColor" class="ma-0" :loading="saveBtn" @click="updateMultipleAtts({review: reviewMode})">{{ lastReview ? 'Verify' : 'Save' }}</v-btn>
                  <template v-if="!lastReview && !reviewMode">
                    <div class="space"></div>
                    <div class="sub-text">RESET PASSWORD</div>
                      <!-- <v-icon :color="primaryColor">expand_more</v-icon> -->
                    <div class="sub-text">Username:<span> {{ userDetails.username }}</span></div>
                    <!-- <v-layout row wrap v-if="mersBranded">
                      <v-flex xs12 lg5 offset-lg1>
                        <v-text-field
                          v-model="userDetails.email"
                          label="Email"
                          :color="appColorHex"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 sm2>
                        <v-select
                          class="country-select"
                          v-model="currentPhones.mobile.countryCode"
                          :items="countries"
                          item-text="label"
                          item-value="value"
                          label="Phone"
                          :color="appColorHex"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6 sm4>
                        <v-text-field
                          v-model="currentPhones.mobile.number"
                          :color="appColorHex"
                          :mask="currentPhones.mobile.countryCode === '1' ? '(###) ### - ####' : '##############'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout> -->
                    <v-layout row wrap>
                      <v-flex xs12 lg5 class="input-group">
                        <div class="Input__inputLabel___3VF0S">Password</div>
                        <v-text-field
                          v-model="userDetails.password"
                          autocomplete="new-password"
                          hint="At least 8 characters, 1 number, 1 lowercase and 1 uppercase letter"
                          persistent-hint
                          :append-icon="showPass1 ? 'visibility' : 'visibility_off'"
                          :rules="[rules.min, rules.upper, rules.number]"
                          :type="showPass1 ? 'text' : 'password'"
                          @click:append="showPass1 = !showPass1"
                          class="default-box pass-one"
                          :color="borderColor"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg5 offset-lg1 class="input-group">
                        <div class="Input__inputLabel___3VF0S">Confirm Password</div>
                        <v-text-field
                          class="default-box"
                          v-model="userDetails.password2"
                          :rules="[rules.match, checkPassword]"
                          :append-icon="showPass2 ? 'visibility' : 'visibility_off'"
                          :type="showPass2 ? 'text' : 'password'"
                          @click:append="showPass2 = !showPass2"
                          :color="borderColor"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-btn dark depressed :color="appButtonColor" class="ma-0" :loading="resetSaveBtn" @click="resetPassword">Save</v-btn>
                    <span :style="{color: responseStyle}">{{ passwordResponse }}</span>
                    <div class="space"></div>
                    <div class="sub-text">TWO-STEP VERIFICATION</div>
                      <!-- <v-icon :color="primaryColor">expand_more</v-icon> -->
                    <div class="sub-text">Preferred Method of Delivery</div>
                    <v-layout row wrap align-center>
                      <v-flex xs12 lg5>
                        <v-radio-group persistent-hint @change="mfaChange" v-model="userDetails.defaultMfa" class="auth-choices">
                          <v-radio
                            v-for="item in mfaOptions"
                            color="#212529"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value"
                          ></v-radio>
                        </v-radio-group>
                        <!-- <v-select
                          v-model="userDetails.defaultMfa"
                          :items="mfaOptions"
                          item-text="text"
                          item-value="value"
                          label="Default MFA"
                          :color="appColorHex"
                          @change="mfaChange"
                        >
                          <template v-if="userDetails.defaultMfa === 'totp'" v-slot:append-outer>
                            <v-icon 
                              color="red"
                              @click.stop="deviceDialog = true"
                              >remove_circle</v-icon
                            >
                          </template>
                        </v-select> -->
                      </v-flex>
                    </v-layout>
                    <v-btn dark depressed :color="appButtonColor" class="ma-0" :loading="mfaSaveBtn" readonly @click="updateMultipleAtts({review: reviewMode})">Save</v-btn>
                  </template>
                  <v-layout row wrap mt-4>
                    <v-flex xs12>
                      <p v-if="mersBranded">Protecting our client's financial data is a high priority for us. MERS will never ask clients verbally or via email/text to verify personal account information, such as passwords, personal identification numbers (PINs), credit or debit card numbers, or other confidential information. We encourage our clients to closely monitor accounts regularly. you should report immediately any suspicious activity to our Service Center at 800-767-6377.</p>
                      <p v-else>Protecting our clients’ financial data is a high priority for us. Alerus will never ask clients verbally or via e-mail/text to update or verify personal or account information, such as passwords, Social Security numbers, personal identification numbers (PINs), credit or debit card numbers, or other confidential information. We encourage our clients to closely monitor accounts regularly. You should report immediately any suspicious activity to our Client Service Center at 833.325.3787.</p>
                    </v-flex>
                  </v-layout>
                <!-- </v-card-text> -->
              <!-- </v-card> -->
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <vue-snotify></vue-snotify>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { $authUser } from "@/plugins/axios";
import countries from "aws-amplify-vue/src/assets/countries";
import states from "@/states"
import { transform, isEqual, isObject, cloneDeep } from "lodash"
import QrcodeVue from 'qrcode.vue'
import { authenticator, totp } from "otplib";
import { JS } from '@aws-amplify/core';
export default {
  name: "preferences",
  data() {
    return {
      showPass1: false,
      showPass2: false,
      valLoading: false,
      deviceDialog: false,
      qrVal: "",
      qrValidate: "",
      qrLoading: false,
      currentUser: {
      },
      currentPhones: {
        mobile: {},
        home: {},
        work: {}
      },
      copyCurrentPhones: {
        mobile: {},
        home: {},
        work: {}
      },
      mfaOptions: [
        {
          text: "Text message",
          value: "sms"
        },
        {
          text: "Phone call",
          value: "voice"
        },
        {
          text: "Authenticator application",
          value: "totp"
        }
      ],
      emptyPhone: {
        countryCode: "1",
        number: "",
        type: ""
      },
      alerusPhone: "833.325.3787",
      mersPhone: "800.767.6377",
      reviewMode: false,
      rules: {
        required: v => !!v || "Required",
        phoneRequired: v => !!v || "Phone is required",
        min: v => v.length >= 8 || v.length === 0 || "Min 8 characters",
        upper: v =>
          /[A-Z]/.test(v) || v.length === 0 || "Must include uppercase letter",
        number: v => /[0-9]/.test(v) || v.length === 0 || "Must include number",
        email: v =>
          /.+@.+/.test(v) || v.length === 0 || "Invalid email address",
        phone: v => v.length === 10 || v.length === 0 || "Phone is invalid",
        match: v =>
          this.userDetails.password === this.userDetails.password2 || v.length === 0 ||
          "Passwords don't match",
        pass: v => this.userDetails.password === this.userDetails.password2 || "Please enter password again"
      },
      newUserAtts: {
        email: "",
        username: "",
        password: "",
        password2: "",
        phone: ""
      },
      addTotp: false,
      totpError: "",
      countries,
      states,
      authUrl: "",
      saveBtn: false,
      mfaSaveBtn: false,
      resetSaveBtn: false,
      dialog: false,
      primaryPhone: [
        {
          title: "Mobile",
          val: "mobile"
        },
        {
          title: "Home",
          val: "home"
        },
        {
          title: "Work",
          val: "work"
        }
      ],
      copy: false,
      qrCode: null,
      editedItem: {},
      clonedItem: {},
      responseStyle: "red",
      tab: null,
      newUrl: false,
      branchLoading: false,
      accountLoading: false,
      actionLoading: false,
      actionTagsLoading: false,
      fullAccountLoading: false,
      system: "",
      phoneResponse: "",
      mfaConfig: {
        mfaTypes: ["TOTP"]
      },
      pagination: {
        descending: true,
        sortBy: "accountName"
      },
      country: "1",
      vendor: [],
      account: [],
      actions: [],
      actionTags: [],
      systems: ["retirement", "avoka", "banking", "wex", "elan", "envestnet"],
      branch: null,
      dashboardReady: false,
      formError: "",
      emailResponse: "",
      branchInfo: "",
      fullAccount: "",
      empty: true,
      token: "",
      authToken: "",
      usernameResponse: "",
      passwordResponse: "",
      color: {
        phone: "light",
        email: "light",
        username: "light",
        password: "light"
      },
      headers: [
        {
          text: "Account ID",
          sortable: true,
          value: "accountID",
          width: "5"
        },
        { text: "Name", sortable: true, value: "accountName" },
        { text: "Type", sortable: true, value: "accountClassification" },
        {
          text: "Investment Account ID",
          sortable: true,
          value: "investmentAccount"
        },
        { text: "Participant ID", sortable: true, value: "participantId" },
        { text: "Plan #", sortable: true, value: "planNumber" },
        { text: "Provider", sortable: true, value: "providerName" },
        { text: "Status", sortable: true, value: "accountStatus" },
        { text: "Balance", sortable: true, value: "balance" }
      ],
      actionHeaders: [
        { text: "Workout", value: "workout" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "phoneNumber" }
      ],
      userHeaders: [
        { text: "Username", value: "username" },
        { text: "Alerus 360 ID", value: "alerusId" },
        { text: "CIF", value: "cif" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "phone" },
        { text: "Date of Birth", value: "dateOfBirth" }
      ]
    };
  },
  watch: {
    async branch() {
      if (this.branch.length === 5) {
        this.branchLoading = true;
        await this.branchLookup(this.branch);
        this.branchLoading = false;
      } else {
        this.branchInfo = "";
      }
    },
    userDetails(val) {
      if (!this.copy) this.copyUserDetails()
    },
    removeColor(val) {
      if (val === true) {
        Object.keys(this.color).forEach(item => (this.color[item] = "light"));
        this.phoneResponse = "";
        this.passwordResponse = "";
        this.usernameResponse = "";
        this.emailResponse = "";
      }
    }
  },
  async created() {
    if (this.userDetails && !this.copy) {
      this.copyUserDetails()
    }
    // let user = await this.$store.dispatch("user/getUserDetails", JSON.stringify({
    //   a360id: this.user.attributes["custom:alerus360id"]
    // }))
    // console.log(user)
    // await this.accountAuth();
    // window.location = await this.getSystem("envestnet");
    // this.getAllEndpoints();
  },
  components: {
    QrcodeVue
  },
  computed: {
    ...mapState("accounts", ["page"]),
    ...mapState("user", ["user", "admin", "links", "snPhones", "mersBranded", "userDetails", "lastReview", "systemAdmin"]),
    userAtts: {
      get() {
        return {
          username: this.user.attributes["preferred_username"],
          email: this.user.attributes.email,
          phone: this.user.attributes["phone_number"],
          alerusId: this.user.attributes["custom:alerus360id"],
          cif: this.user.attributes["custom:cif"],
          dateOfBirth: this.user.attributes["custom:dateofbirth"]
        };
      },
      set(val) {
        if (val[0].Name === "preferred_username") {
          this.user.attributes[val[0].Name] = val[0].Value;
        } else {
          this.user.attributes[val[1].Name] = val[1].Value;
        }
      }
    },
     appColor() {
      return this.mersBranded ? "mers" : "";
    },
    checkPassword() {
      return this.userDetails.password ? this.rules.pass : false
    },
    appColorHex() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#CD493C";
    },
    faqLink() {
      return `An authenticator app is an app that adds two-factor authentication (2FA) to accounts you want to protect. When you set up your account for 2FA, you will receive a secret numerical code to enter into the authenticator app. This establishes a secure connection between the authenticator app and your My Alerus account. To learn more about authenticator app, visit our FAQ.`
    },
    alternatePhones() {
      if (!this.snPhones) return []
      else return this.snPhones.filter(item => {
        if (item.PhoneNumber.length === 10 && item.CountryCode === "1") {
          return (
            this.userAtts.phone !== `+${item.CountryCode}${item.PhoneNumber}`
          );
        } else {
          return this.userAtts.phone !== `+${item.PhoneNumber}`;
        }
      });
    },
    editedPhone() {
      return "+" + this.editedItem.phone;
    },
    updatedAtts() {
      return Object.entries(this.newUserAtts).filter(item => item[1])
    },
    removeColor() {
      if (Object.values(this.newUserAtts).filter(Boolean).length) {
        return true;
      } else return false;
    },
    noDiff() {
      if (Object.keys(this.difference).length || this.phoneDiff.length || this.reviewMode) return false
      else return true
    },
    difference() {
      return transform(this.userDetails, (result, value, key) => {
        if (!isEqual(value, this.currentUser[key])) {
          result[key] = isObject(value) && isObject(this.currentUser[key]) ? difference(value, this.currentUser[key]) : value;
        }
      })
    },
    phoneDiff() {
        return Object.keys(this.currentPhones).reduce((result, key) => {
            if (!this.copyCurrentPhones.hasOwnProperty(key)) {
                result.push(key);
            } else if (_.isEqual(this.currentPhones[key], this.copyCurrentPhones[key])) {
                const resultKeyIndex = result.indexOf(key);
                result.splice(resultKeyIndex, 1);
            }
            return result;
        }, Object.keys(this.copyCurrentPhones));
    },
    userDevices() {
      if (this.userDetails) {
        if (this.userDetails.totpDevices) {
          let devices = JSON.parse(this.userDetails.totpDevices).items
          return devices.map(item => item.name)
        }
        else return []
      }
      else return []
    },
    borderColor() {
      return this.mersBranded ? "#E8E2D0" : "#40A8CB";
    },
    primaryColor() {
      return this.mersBranded ? "#2F6C55" : "#297994"
    },
    subHeader() {
      return this.mersBranded ? "#2F6C55" : "#212529"
    },
    headerColor() {
      return this.mersBranded ? "#2F6C55" : "#0B2A4A";
    },
    siteStyles() {
      return {
        '--border-top': this.borderColor,
        '--primary-color': this.primaryColor,
        '--header-color': this.headerColor,
        '--sub-header-color': this.subHeader
      }
    }
  },
  methods: {
    async deleteDevice() {
      this.userDetails.defaultMfa = "sms"
      this.deviceDialog = false
      await this.updateMultipleAtts({ device: true })
    },
    cancelTotp() {
      this.addTotp = false
      this.userDetails.defaultMfa = this.currentUser.defaultMfa
      this.totpError = ""
      this.qrValidate = ""
    },
    async mfaChange(val) {
      if (val === "totp" && this.currentUser.defaultMfa !== "totp") {
        // if (this.userDevices.length) return
        this.qrCode = authenticator.generateSecret(32)
        this.qrVal = authenticator.keyuri(this.user.username, "Alerus", this.qrCode)
        this.addTotp = true
        await this.$nextTick()
        this.$refs.verifyCode.focus()
        // this.qrCode = await this.$Amplify.Auth.setupTOTP(this.user)
        // this.qrVal = `otpauth://totp/${this.user.username}?secret=${this.qrCode}&issuer=Alerus`
      }
    },
    async validateQrCode() {
      this.totpError = ""
      if (this.qrValidate.length < 6) {
        this.totpError = "Incorrect length of verification code."
        return
      }
      // this.qrLoading = true
      try {
        let isValid = authenticator.check(this.qrValidate, this.qrCode)
        if (isValid) {
          await this.updateMultipleAtts()
          this.addTotp = false
        }
        else throw new Error("Code mismatch")
      } catch (error) {
        if (error.message === "Code mismatch") {
          this.totpError = "Incorrect verification code."
        }
        else this.totpError = error.message
      }
      this.qrValidate = ""
      // this.qrLoading = false
    },
    startReview() {
      this.reviewMode = true
    },
    checkReview() {
      let anyDiff = this.currentUser.email !== this.userDetails.email || this.phoneDiff.length ? true : false
      if (this.reviewMode && !anyDiff) return true
      else return false
    },
    createEmptyPhone(type) {
      let phone = JSON.parse(JSON.stringify(this.emptyPhone))
      phone.type = type
      return phone
    },
    formatPhone(phones, type) {
      let phone = phones.find(item => item.type === type) ? phones.find(item => item.type === type) : this.createEmptyPhone(type)
      let phoneNumber = phone.number.slice(phone.countryCode ? phone.countryCode.length + 1 : 2)
      phone.number = phoneNumber
      if (!phone.countryCode) phone.countryCode = "1"
      return phone
    },
    copyUserDetails() {
      // if (this.userDetails.allowText === null) {
      //   this.userDetails.allowText = false
      // }
      if (!this.userDetails.defaultMfa) {
        this.userDetails.defaultMfa = "sms"
      }
      let allUserDetails = JSON.parse(JSON.stringify(this.userDetails))
      this.currentUser = allUserDetails
      let allPhones = JSON.parse(allUserDetails.phones).items
      this.currentPhones.home = this.formatPhone(allPhones, "home")
      this.currentPhones.mobile = this.formatPhone(allPhones, "mobile")
      this.currentPhones.work = this.formatPhone(allPhones, "work")
      this.copyCurrentPhones = JSON.parse(JSON.stringify(this.currentPhones))
      this.copy = true
    },
    formatUpdates() {
      let format = this.difference
      format.a360id = this.user.attributes["custom:alerus360id"] ? this.user.attributes["custom:alerus360id"] : this.user.attributes["custom:sponsor"]
      format.actionBy = this.userDetails.username
      format.lastReview = new Date().toISOString()
      format.cognitoUsername = this.user.username
      format.email = this.userDetails.email
      return format
    },
    formatPasswordUpdate(pass) {
      let format = {}
      format.password = pass
      format.a360id = this.user.attributes["custom:alerus360id"] ? this.user.attributes["custom:alerus360id"] : this.user.attributes["custom:sponsor"]
      format.actionBy = this.userDetails.username
      format.lastReview = new Date().toISOString()
      format.cognitoUsername = this.user.username
      format.email = this.userDetails.email
      return format
    },
    goToUrl(url) {
      window.location = url;
    },
    resetAccount() {
      this.dialog = false;
      this.emailError = "";
      this.phoneError = "";
    },
    async createEdits() {
      let changes = this.findDifference();
      let updated = await this.$store.dispatch("user/updateUser", {
        newAtts: changes
      });
      if (updated === "Error Saving Changes") {
        this.formError = updated;
      } else this.dialog = false;
    },
    async changePassword() {
      if (!this.$refs.form.validate() || !this.newUserAtts.password) return;
      let res = await this.$store.dispatch(
        "user/updateUserPass",
        this.newUserAtts.password
      );
      return [res, "password"]
    },
    async sleep(secs) {
      return new Promise(resolve => setTimeout(resolve, secs))
    },
    checkBlankPhones(phones) {
      return phones.map(item => {
        if (`+${item.countryCode}` === item.number) {
          item.number = ""
          item.countryCode = ""
        }
        return item
      })
    },
    async resetPassword() {
      if (this.userDetails.password !== this.userDetails.password2) return
      this.resetSaveBtn = true
      let format = this.formatPasswordUpdate(this.userDetails.password)
      let update = await this.$store.dispatch("user/updateMyprofile", {
          func: "editUser",
          arguments: JSON.stringify(format)
      })
      this.$snotify.success("User updated successfully")
      this.resetSaveBtn = false
    },
    async updateMfa() {
      if (this.userDetails.defaultMfa === this.currentUser.defaultMfa) return
      this.mfaSaveBtn = true
      let format = this.formatPasswordUpdate(this.userDetails.password)
      let update = await this.$store.dispatch("user/updateMyprofile", {
          func: "editUser",
          arguments: JSON.stringify(format)
      })
      // this.$snotify.success("User updated successfully")
      this.mfaSaveBtn = false
    },
    async updateMultipleAtts({ review = false, device = false } = {}) {
      if (!this.$refs.form.validate()) return;
      let currReview = this.userDetails.lastReview
      let format = this.formatUpdates()
      // if (device) {
      //   format.removeDevice = true
      // }
      if (this.phoneDiff.length) {
        let diffPhones = this.phoneDiff.map(item => {
          let phone = JSON.parse(JSON.stringify(this.currentPhones[item]))
          phone.number = `+${this.currentPhones[item].countryCode}${this.currentPhones[item].number}`
          return phone
        })
        format.phones = this.checkBlankPhones(diffPhones)
      }

      if (format.defaultMfa) this.mfaSaveBtn = true
      else this.saveBtn = true

      this.copy = false
      
      
      if (format.defaultMfa) {
        if (format.defaultMfa === "totp") {
          format.secret = {
            name: "Default",
            value: this.qrCode
          }
        }
      }

      let update = await this.$store.dispatch("user/updateMyprofile", {
          func: "editUser",
          arguments: JSON.stringify(format)
      })

      // Turn off Review Mode after updating profile
      let path = ""
      if (update && this.reviewMode) {
        // this.reviewMode = false
        path = await this.$store.dispatch("user/editLastReview")
        // Send confirm details log
        this.$store.dispatch("user/createLog", {
          username: this.user.username,
          log: "ConfirmDetails",
          app: "MyAlerus Profile",
          info: JSON.stringify({
            curr: currReview,
            latest: update.lastReview
          })
        })
      }
     
      if (path) {
        this.saveBtn = false
        this.mfaSaveBtn = false
        // Route user to final destination after review
        if (path && path !== this.$router.currentRoute.path) {
          this.$snotify.success("Profile updated successfully. Redirecting...")
          await this.sleep(3000)
          if (this.$router.currentRoute.path !== "/mydocuments") {
            this.$store.commit("user/unsetConfirmed")
          }
          this.$router.push(path)
        }
        else {
          this.$snotify.success("Profile updated successfully")
        }
      }
      else if (this.noDiff) {
        this.saveBtn = false
        this.mfaSaveBtn = false
        this.$snotify.success("Update successful")
      }
      else {
        this.$snotify.error("Error updating")
      }
    },
    async changeAtt(type) {
      if (!this.$refs.form.validate() || !this.newUserAtts[type]) return;
      let val;
      let responseType = `${type}Response`;
      if (type === "email") {
        if (this.userAtts.email === this.newUserAtts.email) {
          this.responseStyle = "green";
          this[responseType] = `${type} updated successfully`;
          this.color[type] = "green";
          this.newUserAtts[type] = "";
          return;
        }
        val = [
          {
            Name: "email_verified",
            Value: true
          },
          {
            Name: "email",
            Value: this.newUserAtts.email
          },
          {
            Name: "current_email",
            Value: this.userAtts.email
          }
        ];
      } else if (type === "phone") {
        if (this.userAtts.phone === `+1${this.newUserAtts.phone}`) {
          this.responseStyle = "green";
          this[responseType] = `${type} updated successfully`;
          this.color[type] = "green";
          this.newUserAtts[type] = "";
          return;
        }
        val = [
          {
            Name: "phone_number_verified",
            Value: true
          },
          {
            Name: "phone_number",
            Value: `+${this.country}${this.newUserAtts.phone}`
          },
          {
            Name: "current_phone",
            Value: this.userAtts.phone
          },
          {
            Name: "custom:countryCode",
            Value: this.country
          }
        ];
      } else if (type === "username") {
        val = [
          {
            Name: "preferred_username",
            Value: this.newUserAtts.username
          }
        ];
      }

      let res = await this.$store.dispatch("user/updateUserAtt", val);
      return [res, type, val, responseType]
    },
    async updateNotification(res, type, val, responseType) {
      if (res) {
        if (type === "phone") {
          this.userAtts = val;
          this.responseStyle = "green";
          this[responseType] = `${type} updated successfully`;
          this.color[type] = "green";
          this.newUserAtts[type] = "";
        } else if (type === "email") {
          this.userAtts = val;
          this.responseStyle = "green";
          this[responseType] = `${type} updated successfully`;
          this.color[type] = "green";
          this.newUserAtts[type] = "";
        }
      } else {
        this.responseStyle = "red";
        this[responseType] = `Error updating ${type}`;
      }
    },
    updatePassNotification(res) {
      if (res) {
        this.responseStyle = "green";
        this.passwordResponse = `password updated successfully`;
        this.color.password = "green";
        this.newUserAtts.password = "";
      } else {
        this.responseStyle = "red";
        this.passwordResponse = "Error updating password";
      }
    },
    async removePhone(phoneId) {
    },
    async updateUser() {
      this.emailError = "";
      this.phoneError = "";
      // Return if any errors are found or if fields are the same
      if (
        this.errors.items.length ||
        (this.clonedItem.phone === this.editedPhone &&
          this.editedItem.email === this.clonedItem.email)
      )
        return;

      // Check email and phone
      if (
        (this.editedItem.email !== this.clonedItem.email &&
          this.clonedItem.phone === this.editedPhone) ||
        (this.editedItem.email !== this.clonedItem.email &&
          this.clonedItem.phone !== this.editedPhone)
      ) {
        if (
          await this.$store.dispatch(
            "user/checkAllEmails",
            this.editedItem.email
          )
        ) {
          this.emailError = "Email already in use";
          return;
        } else this.createEdits();
      } else if (
        this.clonedItem.phone !== this.editedPhone &&
        this.editedItem.email === this.clonedItem.email
      ) {
        this.createEdits();
      }
    },
    findDifference() {
      let vm = this;
      let changes = Object.keys(this.clonedItem).filter(prop => {
        if (prop === "phone") {
          return this.clonedItem[prop] !== this.editedPhone;
        } else return this.clonedItem[prop] !== this.editedItem[prop];
      });
      return changes.map(item => {
        if (item === "phone") {
          return {
            Name: "phone_number",
            Value: this.editedPhone
          };
        } else
          return {
            Name: "email",
            Value: this.editedItem[item]
          };
      });
    },

    updateAtts() {
      this.editedItem = {
        username: this.userAtts["username"],
        email: this.userAtts["email"],
        phone: this.userAtts["phone"]
      };
      this.clonedItem = { ...this.editedItem };
      this.dialog = true;
    },
    async getAllEndpoints() {
      await Promise.all([
        this.getAccount(),
        this.getCallToAction(),
        this.getActionTags(),
        this.getFullAccount()
      ]);
      this.dashboardReady = true;
    },
    async accountAuth() {
      let { data } = await $authUser.get(`/accountAuth`, {
        headers: {
          Authorization: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`
        }
      });
      this.authToken = data;
    },
    formatName(name) {
      let [last, first] = name.split(",");
      return `${first} ${last}`;
    },
    formatAccountName(name) {
      return;
    },
    async getAccount() {
      this.accountLoading = true;
      let { data: account } = await $authUser.get(`/accounts`, {
        headers: {
          Authorization: `Bearer ${this.authToken}`
        }
      });
      this.account = account;
      this.accountLoading = false;
    },
    async getCallToAction() {
      this.actionLoading = true;
      let { data: actions } = await $authUser.get(`/callToAction`, {
        headers: {
          Authorization: `Bearer ${this.authToken}`
        }
      });
      this.actions = actions;
      this.actionLoading = false;
    },
    async getActionTags(userId = 444455555, accountId = "00001555555") {
      this.actionTagsLoading = true;
      let { data: actionTags } = await $authUser.get(
        `/accounts/${accountId}/actionTags`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`
          }
        }
      );
      this.actionTags = actionTags;
      this.actionTagsLoading = false;
    },
    async getFullAccount() {
      this.fullAccountLoading = true;
      let { data: full } = await $authUser.get(
        `https://api.alerus.com/accounts/00001555555?userHandle=444455555&participantId="partipandID"&planNumber=000015`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`
          }
        }
      );
      this.fullAccount = full;
      this.fullAccountLoading = false;
    },
    async branchLookup(branchZip) {
      let { data: branch } = await $authUser.get(
        `/branchCodeLookup?zipCode=${branchZip}`
      );
      this.branchInfo = branch;
    },
    async getSystem(system = this.system) {
      this.newUrl = true;
      let { data: authSystem } = await $authUser.get(
        `/getSystemLink?system=${system}`,
        {
          headers: {
            Authorization: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`
          }
        }
      );
      console.log(authSystem);
      this.authUrl = `https://applanding.alerus.com/?auth=${authSystem}`;
      this.newUrl = false;
      return `https://applanding.alerus.com/?auth=${authSystem}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-list__tile__title {
  font-size: 1.05rem;
}
.pass-one /deep/ {
  .v-messages__message {
    margin-top: .5rem;
  }
}
.alt-phone {
  display: inline-block;
}
.no-scroll {
  overflow: hidden;
}
h2, h3 {
  font-weight: initial;
}
.theme--light .v-list__tile__sub-title {
  color: var(--border-color);
}
.userProps {
  position: relative;
  .edit {
    position: absolute;
    right: 1rem;
    top: 1rem;
    z-index: 1;
  }
  .v-card {
    // cursor: pointer;
    // &:hover {
    //   background-color: #eee;
    // }
    // .v-list {
    //   &:hover {
    //     background-color: #eee;
    //   }
    // }
  }
}
.mers{
  background-color: #33715A !important;
}
.profile .v-card__title {
  background-color: #0C2B4A;
  color: #fff;
  font-size: 1.25rem;
}
span {
  color: red;
  position: relative;
  top: -1rem;
}
.user-card {
  width: 100%;
}
h4 {
  font-weight: initial;
  span {
    color: initial;
    top: initial;
    display: block;
  }
}
</style>

<style lang="scss">
.snotify-success {
  background-color: #5fbc9a;
}
.two-factor {
  padding: 3rem;
  .v-card__title {
    padding: 0;
  }
  .welcome-text {
    margin: 0;
  }
  .main-blue {
    font-size: 2rem;
    font-weight: 600;
    color: var(--header-color);
    margin-bottom: 1rem;
  }
}
.main-profile {
  width: 70%;
  margin: 0 auto;
  border-top: 4px solid;
  border-top-color: var(--border-color);
  background-color: #fff;
  min-height: 450px;
  .main-box {
    padding: 3rem 10rem 5rem;
  }
  .input-group  {
    margin-bottom: 1.5rem;
    input {
      height: 60px;
    }
    .number-input {
      .v-input__slot {
        border-left: none;
      }
    }
  }
  .main-blue {
    margin-bottom: 2rem;
  }
  .sub-text {
    font-size: 18px;
    color: var(--sub-header-color);
    font-weight: 600;
    line-height: 23px;
    margin-bottom: 2rem;
    span {
      font-weight: initial;
      color: initial;
      position: initial;
    }
  }
  input {
    border-radius: 0;
    margin: 0;
  }
  .space {
    border-bottom: 1px solid #ddd;
    padding-top: 3rem;
    margin-bottom: 3rem;
  }
  .default-box {
    margin: 0;
    padding: 0;
    &.v-input--is-focused {
      .v-input__slot {
        border: 1px solid;
        border-color: var(--border-color);
      }
      .v-input__slot::after {
        display: none;
      }
    }
    .v-input__slot {
      margin: 0;
      padding: 16px;
      border: 1px solid #ddd;
      height: 60px;
      &:focus {
        // border: 1px solid #40a8cb;
      }
      &::before {
        display: none;
      }
    }
    input {
      padding: 0;
    }
  }
}
.profile-border {
  border-top: none;
}
.profile-header {
  margin: 1rem 2rem;
  border-bottom: 1px solid #ddd;
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  h1 {
    font-size: 1.25rem;
    padding: .5rem 0;
    color: var(--primary-color);
  }
}
span.totp-error {
  top: initial;
  display: inline-block;
  margin-left: 40px;
  margin-top: .5rem;
  margin-bottom: 1rem;
}
.country-select {
  .v-select__selections {
    padding-top: 0 !important;
  }
}
.review {
  .v-btn__content {
    opacity: initial;
    font-size: inherit;
  }
}
.save .v-btn__content {
  text-transform: initial;
}
.profile {
  .v-subheader {
    color: #000;
  }
}
</style>